






// components/FestivalCalendar.jsx
import React from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction'; // Optional
import { generateFestivalEvents } from '../utils/FestivalEvents';

const CultFestival = () => {
  const events = generateFestivalEvents(2020, 2050);

  return (
    <div className="max-w-7xl mx-auto p-4 bg-[#ffff] shadow-lg rounded-lg">
      <h2 className="text-2xl font-bold mb-4 text-center text-[#cb0c0c]">
        Utah Festival Calendar (2020–2050)
      </h2>
      <FullCalendar
      
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        events={events}
        eventClick={(info) => {
          info.jsEvent.preventDefault(); // prevent default browser action
          if (info.event.url) {
            window.open(info.event.url, "_blank");
          }
        }}
        height="auto"
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,dayGridYear',
        }}
      />
    </div>
  );
};

export default CultFestival;
